import type { FaireProductEntity } from "../../entity_types/product";

export const pom_pom_2: FaireProductEntity = {
  token: "pom-pom-2",
  type: "product",
  name: "Popcorn, Matcha",
  brandName: "Pom Pom Popcorn by Bessou",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9d3f14004e8691ceb2ba4627d9af4302561164dd50a2f690ed65d0f83855e4cf.webp",
  priceDollars: 10,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
